export default __webpack_public_path__ + "static/hero_1-36813c48bd63cc55e3199dc57394ed2e.png";